import { CartItemUpdateSlice } from './types'

export const getCartItemRemove = (itemId: string) => (state: any) => {
  const slice: CartItemUpdateSlice = state.quote.cartItemRemove[itemId]
  return slice ?? {}
}
